import {DepotoCore, Order} from "depoto-core";

export const printTicket = async (order: Order) => {
  // const isZasilkovna = pack.carrier && pack.carrier.id && pack.carrier.id.includes('zasilkovna') // todo test with vhfishing and olicon
  // const isZasilkovna = false
  // const isUlozenka = order.carrier && order.carrier.id && order.carrier.id.includes('ulozenka')
  // const isPpl = order.carrier && order.carrier.id && order.carrier.id.includes('ppl')
  // const isFedexMultipage = order.carrier && order.carrier.id && order.carrier.id.includes('shippypro_fedex')
  // const isPersonally = order.carrier && order.carrier.id && order.carrier.id.includes('personally')
  return printDocument(
    order.billUrl,
    // !!isZasilkovna || !!isUlozenka || !!isPpl || !!isFedexMultipage || !!isPersonally,
    false,
    true,
  )
}

export const printDocument = async (
  url: string,
  isLandscape: boolean = false,
  isLabelPrinter: boolean = true,
  core?: DepotoCore,
): Promise<
  | {
  stdout: string
  stderr: string
  error: string
  filePath: string
  fileName: string
  cmd: string
}
  | any
> => {
  if (!url || url?.length === 0) {
    return null
  }
  const isLinux = navigator.platform?.toLowerCase()?.includes('linux')
  const isDesktopPrint = !!window._depoto && isLinux
  const isPrinter2ByBrowser = !isLabelPrinter && !!window.localStorage.getItem('printer2byBrowser')
  if (!isDesktopPrint && !isPrinter2ByBrowser) {
    // browser: download once with auth and show in new window (opened before any await to avoid popup blocking)
    return openFileInNewWindowWithAuth(url, core)
  }
  const hasError = await checkTicketError(url, core)
  if (hasError) {
    alert('Chyba při stahování tiskových dat účtenky.')
    return
  }
  return new Promise(resolve => {
    if (isPrinter2ByBrowser) {
      return core?.services.download.downloadDocumentAndShowInNewWindow(url, true)
    }
    const printer = isLabelPrinter ? window.localStorage.getItem('printer') : window.localStorage.getItem('printer2')
    const printerWithParams = `${printer}${isLandscape ? ' -o landscape -o fit-to-page ' : ' -o fit-to-page '}`
    const authorizationHeader = getAuthorizationHeaders(core)?.get('Authorization')
    const handleResult = ({ stdout, stderr, error, filePath, fileName, cmd }: any) => {
      console.warn({
        stdout,
        stderr,
        error,
        filePath,
        fileName,
        cmd,
      }) // TODO: remove
      resolve({
        stdout,
        stderr,
        error,
        filePath,
        fileName,
        cmd,
      })
    }
    if (authorizationHeader && window._depoto.node.printLPWithAuth) {
      window._depoto.node.printLPWithAuth(url, authorizationHeader, printerWithParams, handleResult)
    } else {
      window._depoto.node.printLP(url, printerWithParams, handleResult)
    }
  })
}

// getAuthorizationHeaders is implemented by FetchService but missing in the HttpService interface
const getAuthorizationHeaders = (core?: DepotoCore): Headers | undefined =>
  (core?.services.http as unknown as { getAuthorizationHeaders?: () => Headers } | undefined)?.getAuthorizationHeaders?.()

const checkTicketError = async (url: string, core?: DepotoCore) => {
  try {
    const res = await fetch(url, { headers: getAuthorizationHeaders(core) })
    return res.status !== 200
  } catch (e) {
    console.error('checkTicketError failed', e)
    return true
  }
}

const openFileInNewWindowWithAuth = async (url: string, core?: DepotoCore) => {
  const w = window.open('about:blank')
  try {
    const res = await fetch(url, { method: 'POST', headers: getAuthorizationHeaders(core) })
    if (!res.ok) {
      throw new Error(`status ${res.status}`)
    }
    const objectUrl = window.URL.createObjectURL(await res.blob())
    if (w) {
      w.location.href = objectUrl
    }
    window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60_000)
  } catch (e) {
    console.error('Failed to download document', e)
    w?.close()
    alert('Chyba při stahování tiskových dat účtenky.')
  }
  return {
    stdout: 'window.print()',
    stderr: '',
    error: '',
    filePath: url,
    fileName: '',
    cmd: '',
    window: w,
  }
}
